/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SsoGroupMapping } from './SsoGroupMapping';
import {
    SsoGroupMappingFromJSON,
    SsoGroupMappingFromJSONTyped,
    SsoGroupMappingToJSON,
    SsoGroupMappingToJSONTyped,
} from './SsoGroupMapping';

/**
 * 
 * @export
 * @interface GetOrganizationSsoGroupMappings200Response
 */
export interface GetOrganizationSsoGroupMappings200Response {
    /**
     * 
     */
    data?: Array<SsoGroupMapping>;
}

/**
 * Check if a given object implements the GetOrganizationSsoGroupMappings200Response interface.
 */
export function instanceOfGetOrganizationSsoGroupMappings200Response(value: object): value is GetOrganizationSsoGroupMappings200Response {
    return true;
}

export function GetOrganizationSsoGroupMappings200ResponseFromJSON(json: any): GetOrganizationSsoGroupMappings200Response {
    return GetOrganizationSsoGroupMappings200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationSsoGroupMappings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationSsoGroupMappings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SsoGroupMappingFromJSON)),
    };
}

export function GetOrganizationSsoGroupMappings200ResponseToJSON(json: any): GetOrganizationSsoGroupMappings200Response {
    return GetOrganizationSsoGroupMappings200ResponseToJSONTyped(json, false);
}

export function GetOrganizationSsoGroupMappings200ResponseToJSONTyped(value?: GetOrganizationSsoGroupMappings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SsoGroupMappingToJSON)),
    };
}

